<template>
    <div>
        <ul id="slide-out" class="sidenav fixed z-depth-2" style="transform: translateX(0%);">
            <li class="center no-padding">
                <div class="teal light-2 white-text" style="height: 180px;">
                    <div class="row">
                        <img style="margin-top: 5%;" width="100" height="100" src="../../../assets/svg/ads-svgrepo-com.svg" class=" responsive-img" />
                        <p style="margin-top: -3%;">
                            Circular de Ofertas
                        </p>
                    </div>
                </div>
            </li>

            <li id="dash_dashboard"><router-link to="/" class="waves-effect" style="padding: 0 16px;"><b>Dashboard</b></router-link></li>

            <!-- <li><a class="dropdown-trigger" href="#!" data-target="dropdown1">Circular<i class="material-icons right">arrow_drop_down</i></a></li>
            <ul id='dropdown1' class='dropdown-content'>
                <li>
                    <router-link to="/nova-circular" class="waves-effect" style="text-decoration: none;">
                        Nova
                    </router-link>
                </li>
                <li>
                    <router-link to="/gerar" class="waves-effect" style="text-decoration: none;">
                        Gerar
                    </router-link>
                </li>
            </ul> -->
            <ul class="collapsible" data-collapsible="accordion">
                <li id="dash_users">
                    <div id="dash_users_header" class="collapsible-header waves-effect"><b>Circular</b></div>
                    <div id="dash_users_body" class="collapsible-body">
                        <ul>
                            <li id="users_seller">
                                <router-link to="/nova-circular" class="waves-effect" style="text-decoration: none;">
                                    Nova
                                </router-link>
                            </li>

                            <li id="users_customer">
                                <router-link to="/gerar" class="waves-effect" style="text-decoration: none;">
                                    Gerar
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </li>

                <li id="dash_products">
                    <div id="dash_products_header" class="collapsible-header waves-effect"><b>Relatórios</b></div>
                    <div id="dash_products_body" class="collapsible-body">
                        <ul>
                            <li id="products_product">
                                <a class="waves-effect" style="text-decoration: none;" href="#!">Produtos mais usados</a>
                                <a class="waves-effect" style="text-decoration: none;" href="#!">Templates mais usados</a>
                            </li>
                        </ul>
                    </div>
                </li> 
            </ul>
        </ul>
    </div>
</template>

<script>
export default {
    name: "side_menu",
    mounted() {
        $(document).ready(function(){
            $('.collapsible').collapsible();
            $('.sidenav').sidenav();
        });
    }
}
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/components/shared/side_menu/SideMenu.vue